import React from 'react';
import {useTranslation} from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {DialogActions, DialogTitle} from "@material-ui/core";

export const ConfirmationPrompt = ({
                                       title,
                                       description,
                                       warning,
                                       open,
                                       onCancel,
                                       onConfirm,
                                       disable,
                                       confirmationButtonKey
                                   }: any) => {
    const {t} = useTranslation();
    const confirmationButtonText = confirmationButtonKey ? t(confirmationButtonKey) : t('_Common.Labels.Delete');

    return <Dialog open={open} onClose={onCancel}>
        <DialogTitle>
            {title}
        </DialogTitle>
        <DialogContent dividers>
            <Typography>
                {description}
            </Typography>
            {warning && <Typography color='error' variant='body2'>
                {warning}
            </Typography>}
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" color="primary" size="medium"
                    onClick={onCancel}
                    disabled={disable}>
                {t('_Common.Labels.Cancel')}
            </Button>
            <Button variant="contained" color="primary" size="medium"
                    onClick={onConfirm}
                    disabled={disable}>
                {confirmationButtonText}
            </Button>
        </DialogActions>
    </Dialog>
};
